import { Theme, themeQuartz } from 'ag-grid-community';

export const defaultColDef = {
  flex: 1,
  headerComponentParams: {
    menuIcon: 'fa-filter',
    suppressMenu: false,
    showColumnMenu: true,
  },
  suppressMenu: true,
};

export const theme: Theme = themeQuartz.withParams({
  selectedRowBackgroundColor: 'rgba(171, 228, 255, 0.61)',
  oddRowBackgroundColor: '#8881',
});
